import { render, staticRenderFns } from "./orderTcCgApprove.vue?vue&type=template&id=a56af7b6&scoped=true"
import script from "./orderTcCgApprove.vue?vue&type=script&lang=js"
export * from "./orderTcCgApprove.vue?vue&type=script&lang=js"
import style0 from "./orderTcCgApprove.vue?vue&type=style&index=0&id=a56af7b6&prod&scoped=true&lang=css"
import style1 from "./orderTcCgApprove.vue?vue&type=style&index=1&id=a56af7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56af7b6",
  null
  
)

export default component.exports